import { useState, useCallback, createContext } from 'react'
import { useIntl } from 'react-intl'
import { Card, Button } from '@material-ui/core'
import { Add as AddIcon } from '@material-ui/icons'
import { makeStyles } from '@material-ui/core/styles'
// import useCheckCreateSurvey from 'hooks/useCheckCreateSurvey'
import SelectCreateBox from './SelectCreateBox'

interface Props {
    survey_workspace_no: number
    onChangeOpenCreateSurvey: (a: boolean) => void;
}

const useStyles = makeStyles(theme => ({
    add: {
        height: 180,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer'
    }
}))

export type OnOpen = () => void
export type OnCreate = () => void

export const AddContext = createContext({
    survey_workspace_no: 0
})

function AddComponent(props: Props) {
    const [ open, setOpen ] = useState(false)

    const { survey_workspace_no, onChangeOpenCreateSurvey } = props

    const { formatMessage: f } = useIntl()

    const classes = useStyles()

    /* 
    const [ onCheckCreateSurvey ] = useCheckCreateSurvey('cache-first')
    */

    const handleOpen = useCallback(() => {
        setOpen(true)
    }, [])

    const handleClose = useCallback(() => {
        setOpen(false)
    }, [])

    const handleCreate = useCallback(() => {
        // const result = onCheckCreateSurvey()
        const result = 1
        
        handleClose()
        
        if (result) {
            onChangeOpenCreateSurvey(true)   
        }
    }, [handleClose, onChangeOpenCreateSurvey])

    return (
        <>
        <Card className={classes.add} variant="outlined" onClick={handleOpen}>
            <Button size='large' startIcon={<AddIcon/>}>
                {f({id: 'component.Survey.Workspace.Body.Add.button.add'})}
            </Button>
        </Card>
        <AddContext.Provider value={{survey_workspace_no}}>
            <SelectCreateBox open={open} onClose={handleClose} onCreate={handleCreate}/>
        </AddContext.Provider>
        </>
    )
}

export default AddComponent